import "./App.css";
import AppRouter from "./appRouter";
import { Provider } from "react-redux";
import store from "./Redux/store";
// import useScanDetection from 'use-scan-detection';
import { useEffect, useState } from "react";
import axios from "axios";
import { Base_Uri } from "./Constant/BaseUri";
import { IS_EDIT_OPEN, NETWORK_STATUS, SELECTED_CUSTOMER, SELECTED_INVOICES, SOCKETS } from "./Context";
import { RiWifiOffLine } from "react-icons/ri";


import {
  Font,
} from "@react-pdf/renderer";
import OfflineBanner from "./Components/OfflineBanner";
import { bootstrapProducts } from "./Sycn/bootstrapProducts";
import { downloadProductChanges } from "./Sycn/downloadProductChanges";

// //import MyFontRegular from "/fonts/Poppins-Medium.ttf";
// import MyFontBold from "/fonts/Poppins-Bold.ttf";

Font.register({
        family: 'MyFont',
        fonts: [
            { src: "/fonts/Poppins-Bold.ttf", fontWeight: 'bold' },
            { src: "/fonts/Poppins-Medium.ttf", fontWeight: 'normal' },
        ]
    });

function App() {
  const [barcode, setBarcode] = useState("");
  const [allowedCountries, setAllowedCountries] = useState([]);

  // const fetchCountries = () => {
  //   axios.get(`${Base_Uri}countries`)
  //     .then(res => setAllowedCountries(res.data))
  //     .catch(err => console.error("Error fetching countries:", err));
  // };
  const [isAllowed, setIsAllowed] = useState(false);

  // useScanDetection({
  //   onComplete: (code) => {

  //     setBarcode(code)

  // useEffect(()=>{
  //   fetchCountries()
  // },[])

  const [userData, setUserData] = useState([]);
  const [selectedInvoice, setSelectedInvoice] = useState("");
  const [selectCustomerId,setSelectedCustomerId] = useState({})
  const [socketsData,setSocketsData] = useState(null)
  const [isEditOpen,setIsEditOpen] = useState(false)

  // useEffect(() => {
  //   fetch("https://api64.ipify.org?format=json")
  //     .then((res) => res.json())
  //     .then((data) => {setIp(data.ip)
  //       console.log(data.ip)
  //     })
  //     .catch((err) => console.error(err));
  // }, []);

  // useEffect(() => {
  //   fetch("http://ip-api.com/json/")
  //     .then((res) => res.json())
  //     .then((data) => setUserData(data)); // Full country name (e.g., "United States")
  // }, []);

  // useEffect(()=>{
  //     let checkAccess = allowedCountries.filter(e=>e.code==userData.countryCode)
  //     setIsAllowed(checkAccess.length!=0)
  // },[allowedCountries,userData])

  const [networkStatus, setNetworkStatus] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => {
      console.log("Back Online");
      setNetworkStatus(true);
    };

    const handleOffline = () => {
      console.log("Offline");
      setNetworkStatus(false);
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

    useEffect(() => {
  const init = async () => {
    if (!localStorage.getItem("bootstrapped")) {
      await bootstrapProducts();
      localStorage.setItem("bootstrapped", "true");
    }
  };

  init();

  const handleOnline = async () => {
    await downloadProductChanges();
  };

  window.addEventListener("online", handleOnline);

  return () => {
    window.removeEventListener("online", handleOnline);
  };
}, []);

  useEffect(() => {
    console.log(networkStatus, "navigator.onLine");
  }, [networkStatus]);

  return (
    <>
    <NETWORK_STATUS.Provider value={{networkStatus, setNetworkStatus}}>
    <SOCKETS.Provider value={{socketsData,setSocketsData}}>

    <SELECTED_INVOICES.Provider  value={{selectedInvoice, setSelectedInvoice}}>
    <SELECTED_CUSTOMER.Provider  value={{selectCustomerId,setSelectedCustomerId}}>
      <IS_EDIT_OPEN.Provider value={{isEditOpen,setIsEditOpen}}>

 <Provider store={store}>
      {
        <div className="App">
          <AppRouter />
        </div>
      }
      {/* { <div className="restricted-container">
      <div className="warning-icon">⚠️</div>
      <h1>Access Denied</h1>
      <p>Sorry, your country is restricted from accessing this content.</p>
      
    </div>} */}
      <div
        style={{
          fontFamily: "Poppins",
          fontSize: 12,
          color: "#6e6e6e",
          fontWeight: "600",
          position: "fixed",
          bottom: 5,
          right: 5,
        }}
      >
        V1.2 (BETA)
      </div>
    </Provider>
      </IS_EDIT_OPEN.Provider>
    </SELECTED_CUSTOMER.Provider>
    </SELECTED_INVOICES.Provider>
    </SOCKETS.Provider>
    </NETWORK_STATUS.Provider>
    {!networkStatus?<div style={{width:100,height:30,background:"#e57373",position:"absolute",bottom:10,left:10,borderRadius:10,display:"flex",alignItems:"center",justifyContent:"center"}}>
        <div style={{color:"#dd0d0d",fontSize:12,fontWeight:"bold",gap:10,display:"flex",alignItems:"center",justifyContent:"center"}}>
          <RiWifiOffLine size={20} color="#dd0d0d" />
          <div>
            OFFLINE
          </div>
          </div>
    </div>:<></>}
    </>
   
  );
}

export default App;
